import CorporateMarketChart from './CorporateMarketChart';

export default CorporateMarketChart;
